var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"gs-asset-segment",attrs:{"role":"tablist","aria-label":_vm.label}},_vm._l((_vm.items),function(item){return _c('button',{key:item.value,staticClass:"gs-asset-segment__item",class:{
      'is-active': _vm.current === item.value,
      'has-error': _vm.hasError(item),
    },attrs:{"type":"button","role":"tab","aria-selected":_vm.current === item.value ? 'true' : 'false'},on:{"click":function($event){return _vm.$emit('select', item.value)}}},[_vm._v(" "+_vm._s(item.title)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }